(ns common.resource.sso
  (:require [common.db.coeffects.cookie]
            [common.url-template :as url-tpl]
            [medley.core :as medley]
            [re-frame.core :as rf]))

(rf/reg-event-fx ::get-token-with-sso-token
  [(rf/inject-cofx :sub :url-context)
   (rf/inject-cofx :sub :common.os/os)]
  (fn [{:keys [url-context]
        :common.os/keys [os]} [_ {:keys [token on-failure]}]]
    (let [agency-id (some-> (:agency-id url-context) js/parseInt)]
      {:http
       {:method :post
        :uri (url-tpl/render :api/get-token-with-sso-token url-context)
        :params (cond-> {:sso-token (or (:access-token token) (:access_token token))}
                  (and (empty? os) agency-id) (assoc :agency-id agency-id)
                  os (assoc :wpp-open (->> {:project-id (get-in os [:context :project :id])
                                            :tenant-id (get-in os [:context :tenant :id])
                                            :workspace-id (get-in os [:context :workspace :azId])
                                            ;; TODO This should be loaded by backend from the config,
                                            ;; using it as a temporary solution to support multiple apps
                                            :app-id (get-in os [:context :appInstance :devhubAppId])
                                            :app-version (get-in os [:context :appInstance :devhubAppVersionId])}
                                           (medley/remove-vals nil?))))
        :on-success [:resource.user/merge-value]
        :on-failure [::sso-failure {:on-failure on-failure}]}})))

(rf/reg-event-fx ::sso-login
  (fn [{:keys [db]} [_ {:keys [token on-failure]}]]
    {:db (assoc-in db [:resource.auth/auth :status] :log-in)
     :fx [[:async-flow {:id ::sso-flow
                        :first-dispatch [::get-token-with-sso-token {:token token :on-failure on-failure}]
                        :rules [{:when :seen?
                                 :events :resource.user/merge-value
                                 :dispatch [:resource.user/get-me]}
                                {:when :seen?
                                 :events :resource.user/get-me-failure
                                 :halt? true
                                 :dispatch [::sso-failure {:on-failure on-failure}]}
                                {:when :seen?
                                 :events :resource.user/get-me-success
                                 :halt? true
                                 :dispatch [:resource.auth/login-success]}]}]]}))

(rf/reg-event-fx ::sso-token-success
  [(rf/inject-cofx :sub :common.os/token)]
  (fn [{os-token :common.os/token} [_ {:keys [token on-failure]}]]
    (let [token (or token {:access-token os-token})
          id-token (or (:id-token token) (:id_token token))]
      (when-not id-token
        (js/console.warn "SSO id-token not found in token response. GA4 user data extraction may fail."))
      {:fx [[:dispatch [::sso-login {:token token :on-failure on-failure}]]
            [:sessionstorage/save ["sso-id-token" id-token]]]})))

(rf/reg-event-fx ::sso-failure
  (fn [_ [_ {:keys [on-failure]} _]]
    {:fx [(when on-failure [:dispatch on-failure])]}))

(rf/reg-event-fx ::fetch-sso-token-with-code
  [(rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context]} [_ {:keys [data on-failure]}]]
    {:http {:method :get
            :uri (url-tpl/render :api/sso-token url-context)
            :params data
            :on-success (fn [response]
                          (rf/dispatch [::sso-token-success {:token response :on-failure on-failure}]))
            :on-failure [::sso-failure {:on-failure on-failure}]}}))
